import { IWbAppInfo, IWbUserInfo } from '@interco/inter-webview-bridge'

export const BridgeMockUserInfo: IWbUserInfo = JSON.parse(process.env.REACT_APP_USER_INFO || '{}')
export const BridgeMockAppInfo: IWbAppInfo = JSON.parse(process.env.REACT_APP_APP_INFO || '{}')
